import { NavLink, Outlet, Link } from "react-router-dom";
import { useMe } from "../../hooks/useMe";
import AdminMfaSetup from "./AdminMfaSetup";

const LINKS = [
  { to: ".", label: "Dashboard", end: true },
  { to: "customers", label: "Customers" },
  { to: "subscriptions", label: "Subscriptions" },
  { to: "catalog", label: "Catalog" },
  { to: "imports", label: "Imports & Rights" },
  { to: "offers", label: "Offers" },
  { to: "billing", label: "Billing" },
  { to: "manuscripts", label: "Manuscripts" },
  { to: "muscle-school", label: "Muscle School" },
  { to: "gold", label: "Gold Vault" },
  { to: "journeys", label: "Journeys" },
  { to: "growth", label: "Growth" },
  { to: "security", label: "Security Log" },
];

export default function AdminLayout() {
  const { data: me, isLoading } = useMe();

  if (isLoading) return <div className="min-h-[60vh]" />;
  if (!me || me.role !== "admin") {
    return (
      <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="admin-forbidden">
        <p className="text-white/60 mb-4">Administration Studio access requires Director authorization.</p>
        <Link to="/" className="underline text-sm">Back to home</Link>
      </div>
    );
  }
  if (!me.mfa_verified) {
    return <AdminMfaSetup />;
  }

  return (
    <div className="flex max-w-[1600px] mx-auto" data-testid="admin-studio">
      <aside className="w-56 shrink-0 border-r border-white/10 px-6 py-10 hidden md:block">
        <p className="text-xs uppercase tracking-widest text-white/70 mb-6">Administration Studio</p>
        <nav className="space-y-3">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `block text-sm ${isActive ? "text-brandAccent" : "text-white/60 hover:text-white"}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="flex-1 px-6 md:px-10 py-10 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
